document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-instagram-slider]').forEach((slider) => {
    if (!slider) return;
    // Swiper init stays the same
    const slidesDesktop = parseFloat(slider.dataset.slidesDesktop) || 4;
    const slidesMobile = parseFloat(slider.dataset.slidesMobile) || 1.2;
    const spaceBetween = parseInt(slider.dataset.space, 10) || 20;
    const loop = slider.dataset.loop === 'true';
    const centered = slider.dataset.centered === 'true';
    const showArrows = slider.dataset.arrows === 'true';

    new Swiper(slider, {
      slidesPerView: slidesMobile,
      spaceBetween,
      centeredSlides: centered,
      loop,
      a11y: false,
      breakpoints: {
        750: {
          slidesPerView: slidesDesktop,
          pagination: false,
        },
      },
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: showArrows
        ? {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          }
        : false,
    });

    slider.querySelectorAll('[data-placeholder]').forEach((placeholder) => {
      if (!placeholder) return;
      placeholder.addEventListener('click', () => {
        const wrapper = placeholder.closest('.instagram-videos__video-wrapper');
        const video = wrapper.querySelector('video[data-video]');

        // Start loading video
        video.classList.remove('is-hidden');
        video.load();

        // Once video is ready, remove placeholder and play
        video.addEventListener(
          'canplay',
          () => {
            placeholder.remove();
            video.play().catch(() => {});
          },
          { once: true },
        );
      });
    });

    /* Pause other videos when one plays */
    slider.querySelectorAll('video[data-video]').forEach((video) => {
      video.addEventListener('play', () => {
        slider.querySelectorAll('video[data-video]').forEach((other) => {
          if (other !== video) other.pause();
        });
      });
    });
  });
});
